import React, { useEffect, useState } from 'react';
import axios from 'axios';

function CommWeighing() {
  const [commodities, setCommodities] = useState([]);
  const [userSelected, setUserSelected] = useState({});
  const [obSelected, setObSelected] = useState({});
  const [weighingEnabled, setWeighingEnabled] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');
  const [manualWeighingAction, setManualWeighingAction] = useState({}); 
  const [manualObAction, setManualObAction] = useState({}); 

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL}/api/commodityList`)
      .then(response => {
        const data = response.data;
        setCommodities(data);

        const savedUserSelected = JSON.parse(localStorage.getItem('userSelected') || '{}');
        const userState = {};
        data.forEach(commodity => {
          const key = commodity.commId.toString();
          userState[key] = savedUserSelected[key] ?? (commodity.weighing?.toLowerCase() === 'y');
        });
        setUserSelected(userState);

        const savedObSelected = JSON.parse(localStorage.getItem('obSelected') || '{}');
        const obState = {};
        data.forEach(commodity => {
          const key = commodity.commId.toString();
          obState[key] = savedObSelected[key] ?? (commodity.obUpdate?.toLowerCase() === 'y');
        });
        setObSelected(obState);

        const savedStatus = JSON.parse(localStorage.getItem('weighingEnabled') || 'false');
        setWeighingEnabled(savedStatus);
      })
      .catch(error => console.error('Error fetching commodity list:', error));
  }, []);

  useEffect(() => localStorage.setItem('userSelected', JSON.stringify(userSelected)), [userSelected]);
  useEffect(() => localStorage.setItem('obSelected', JSON.stringify(obSelected)), [obSelected]);
  useEffect(() => localStorage.setItem('weighingEnabled', JSON.stringify(weighingEnabled)), [weighingEnabled]);

  const handleRowSelection = (commId) => {
    const key = commId.toString();
    setUserSelected(prev => ({ ...prev, [key]: !prev[key] }));
    setManualWeighingAction(prev => ({
      ...prev,
      [key]: !userSelected[key] ? 'enable' : 'disable'
    }));
  };

  const handleObSelection = (commId) => {
    const key = commId.toString();
    setObSelected(prev => ({ ...prev, [key]: !prev[key] }));
    setManualObAction(prev => ({
      ...prev,
      [key]: !obSelected[key] ? 'enable' : 'disable'
    }));
  };

  const updateWeighingStatus = async (status) => {
    try {
      const updates = [];
      const keysToUpdate = [];
      const actionType = status ? 'enable' : 'disable';

      Object.keys(manualWeighingAction).forEach(key => {
        if (manualWeighingAction[key] === actionType) {
          updates.push({
            commId: parseInt(key),
            commNameEn: commodities.find(c => c.commId.toString() === key).commNameEn,
            weighing: status ? 'Y' : 'N',
          });
          keysToUpdate.push(key);
        }
      });

      if (updates.length === 0) {
        setResponseMsg(`No commodities selected to ${status ? 'enable' : 'disable'} Weighing.`);
        return;
      }

      for (const item of updates) {
        await axios.post(`${process.env.REACT_APP_URL}/api/updateWeighing`, item);
      }

      setUserSelected(prev => {
        const updated = { ...prev };
        keysToUpdate.forEach(key => { updated[key] = status; });
        return updated;
      });

      setManualWeighingAction(prev => {
        const updated = { ...prev };
        keysToUpdate.forEach(key => { delete updated[key]; });
        return updated;
      });

      setCommodities(prev =>
        prev.map(comm =>
          keysToUpdate.includes(comm.commId.toString())
            ? { ...comm, weighing: status ? 'Y' : 'N' }
            : comm
        )
      );

      setResponseMsg(`Weighing status ${status ? 'Enable' : 'Disable'} updated successfully.`);
    } catch (error) {
      console.error('Error updating weighing status:', error.response?.data || error.message);
      setResponseMsg('Failed to update weighing status.');
    }
  };

  const updateObStatus = async (status) => {
    try {
      const updates = [];
      const keysToUpdate = [];
      const actionType = status ? 'enable' : 'disable';

      Object.keys(manualObAction).forEach(key => {
        if (manualObAction[key] === actionType) {
          updates.push({
            commId: parseInt(key),
            commNameEn: commodities.find(c => c.commId.toString() === key).commNameEn,
            obUpdate: status ? 'Y' : 'N',
          });
          keysToUpdate.push(key);
        }
      });

      if (updates.length === 0) {
        setResponseMsg(`No commodities selected to ${status ? 'enable' : 'disable'} OB.`);
        return;
      }

      for (const item of updates) {
        await axios.put(`${process.env.REACT_APP_URL}/api/updateOb`, null, { params: item });
      }

      setObSelected(prev => {
        const updated = { ...prev };
        keysToUpdate.forEach(key => { updated[key] = status; });
        localStorage.setItem('obSelected', JSON.stringify(updated));
        return updated;
      });

      setManualObAction(prev => {
        const updated = { ...prev };
        keysToUpdate.forEach(key => { delete updated[key]; });
        return updated;
      });

      setCommodities(prev =>
        prev.map(comm =>
          keysToUpdate.includes(comm.commId.toString())
            ? { ...comm, obUpdate: status ? 'Y' : 'N' }
            : comm
        )
      );

      setResponseMsg(`OB status ${status ? 'Enable' : 'Disable'} updated successfully.`);
    } catch (error) {
      console.error('Error updating OB status:', error.response?.data || error.message);
      setResponseMsg('Failed to update OB status.');
    }
  };

  return (
    <div className="wrapper row3">
      <div id="container">
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <table width="50%" border="1" cellPadding="4" style={{ borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ backgroundColor: 'black' }}>
                <th colSpan="4" style={{ textAlign: 'center', color: 'white', fontSize: '20px' }}>Commodity Weighing</th>
              </tr>
              <tr style={{ backgroundColor: 'black' }}>
                <th style={{ color: 'white', width: '50px' }}>Sl No</th>
                <th style={{ color: 'white', width: '150px' }}>Commodity</th>
                <th style={{ color: 'white', width: '150px' }}>Weighing</th>
                <th style={{ color: 'white', width: '100px' }}>OB Update</th>
              </tr>
            </thead>
            <tbody>
              {commodities.length > 0 ? (
                commodities.map((commodity, index) => {
                  const key = commodity.commId.toString();
                  const isSelected = userSelected[key] ?? (commodity.weighing?.toLowerCase() === 'y');
                  const isObChecked = obSelected[key] ?? (commodity.obUpdate?.toLowerCase() === 'y');

                  return (
                    <tr key={commodity.commId}>
                      <td>{index + 1}</td>
                      <td>{commodity.commNameEn}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <button onClick={() => handleRowSelection(commodity.commId)} style={checkboxStyle}>
                          {isSelected ? '✔' : ''}
                        </button>
                      </td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <button onClick={() => handleObSelection(commodity.commId)} style={checkboxStyle}>
                          {isObChecked ? '✔' : ''}
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center' }}>No commodities found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', gap: '10px' }}>
          <button onClick={() => updateWeighingStatus(true)} style={buttonStyle}>Weighing Enable</button>
          <button onClick={() => updateWeighingStatus(false)} style={buttonStyle}>Weighing Disable</button>
          <button onClick={() => updateObStatus(true)} style={buttonStyle}>OB Enable</button>
          <button onClick={() => updateObStatus(false)} style={buttonStyle}>OB Disable</button>
        </div>

        {responseMsg && (
          <div
            style={{
              marginTop: '15px',
              textAlign: 'center',
              color: responseMsg.includes('Failed') ? 'red' : 'green',
              fontWeight: 'bold',
              fontSize: '25px'
            }}
          >
            {responseMsg}
          </div>
        )}
      </div>
    </div>
  );
}

const buttonStyle = {
  padding: '10px 20px',
  backgroundColor: 'black',
  color: 'white',
  border: 'none',
  borderRadius: '12px',
  cursor: 'pointer',
  fontSize: '12px',
  width: '150px',
  height: '30px',
  fontFamily: 'Arial, sans-serif',
  fontWeight: 'bold',
};

const checkboxStyle = {
  fontSize: '14px',
  backgroundColor: 'transparent',
  color: 'black',
  border: '1px solid #ccc',
  borderRadius: '0px',
  cursor: 'pointer',
  width: '15px',
  height: '15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  margin: '0 auto',
};

export default CommWeighing;
